import { type DataTableVariant, getDataTableComponent } from "@msuite/ui/table";
import { useSuborderLoadCarriers } from "@/hooks/use-suborder-load-carriers";
import { columns } from "./table-config";

/** Props Interface */
interface SuborderLoadCarriersTableProps {
	orderId: string;
	suborderId: string;
	variant?: DataTableVariant;
}

/**
 * The load carriers going along with one picking round — the counterpart to its article lines.
 *
 * A round has both kinds of work and neither is a subset of the other: the boxes and pallets the
 * goods travel in are attached here, and an order that asked for empties as Leergut is picked here
 * alone. Nothing is edited from this table; the handheld's carrier step is what writes a line, and
 * the sign-off is what books it.
 */
export function SuborderLoadCarriersTable({
	orderId,
	suborderId,
	variant = "sub-table",
}: SuborderLoadCarriersTableProps) {
	/** Query */
	const { loadCarriers, isLoading, queryKey, refetch } = useSuborderLoadCarriers(
		orderId,
		suborderId,
	);

	/** Computed */
	const Table = getDataTableComponent(variant);

	/** Render */
	return (
		<Table
			variant={variant}
			data={loadCarriers}
			columns={columns}
			persistenceKey="suborder-load-carriers-table"
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={null}
		/>
	);
}
